import React, { useEffect } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import AOS from "aos";
import Header from "../Includes/Header";
import Footer from "../Includes/Footer";
import Sidebar from "../Includes/Sidebar";
// import "./SolidWasteManagement.css";

const Manpower = () => {
  useEffect(() => {
    AOS.init({ duration: 900, once: true });
  }, []);

  return (
    <main className="boxed_wrapper ">
      <Header />

           <section
  className="mr_page_page_title page-title"
  style={{
    position: "relative",
    backgroundImage: `url('/start.jpg')`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    height: "320px",
    display: "flex",
    alignItems: "center"
  }}
>
  {/* Dark Overlay */}
  <div
    style={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0, 0, 0, 0.45)"
    }}
  ></div>

  <div className="auto-container" style={{ position: "relative", zIndex: 2 }}>
    <div className="content-box">
      <h1
        className="mr_banner_title mr_xpage"
        style={{
          color: "#fff",
          fontSize: "48px",
          fontWeight: "700",
          textShadow: "0 3px 6px rgba(0,0,0,0.6)"
        }}
      >
      Manpower Services and Staffing
      </h1>
    </div>
  </div>
</section>
      {/* sidebar-page-container */}
      <section className=" sidebar-page-container  ">
        <div className="auto-container">
          <div className="row clearfix">
            <div className="content-side col-12">
              <div className="wp-style">
                <div className="text">
                  <div
                    data-elementor-type="wp-page"
                    data-elementor-id={1502}
                    className="elementor elementor-1502"
                  >
                    <section
                      className="elementor-section elementor-top-section elementor-element elementor-element-577aab15 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                      data-id="577aab15"
                      data-element_type="section"
                    >
                      <div className="elementor-container elementor-column-gap-no">
                        <div
                          className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-7def736e"
                          data-id="7def736e"
                          data-element_type="column"
                          data-settings='{"background_background":"classic"}'
                        >
                         <Sidebar />
                        </div>

                        
                        <div
                          className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-4c2b897e"
                          data-id="4c2b897e"
                          data-element_type="column"
                        >
                          <div className="elementor-widget-wrap elementor-element-populated">
                            <div
                              className="elementor-element elementor-element-49061c4c elementor-widget elementor-widget-image"
                              data-id="49061c4c"
                              data-element_type="widget"
                              data-widget_type="image.default"
                            >
                             <div className="service-image-wrapper">
  <img
    src="/containimg_57.jpg"
    alt="service"
    className="service-image"
  />
</div>
 
                            </div>
                            <div
                              className="elementor-element elementor-element-1a3cff60 elementor-widget elementor-widget-heading"
                              data-id="1a3cff60"
                              data-element_type="widget"
                              data-widget_type="heading.default"
                            >
                              <div className="elementor-widget-container">
                                <h2 className="elementor-heading-title elementor-size-default">
                                  Manpower services
                                </h2>{" "}
                              </div>
                            </div>
                            <div
                              className="elementor-element elementor-element-4dd89693 elementor-widget elementor-widget-text-editor"
                              data-id="4dd89693"
                              data-element_type="widget"
                              data-widget_type="text-editor.default"
                            >
                              <div className="elementor-widget-container">
                                We provide manpower services, including skilled, semi-skilled, and unskilled technical and non-technical personnel, as well as high-profile security services. Our clientele includes industries, corporate/private and public sectors, municipalities, government organizations, and non-profit organizations. Our growth has been driven by steadfast adherence to business ethics, transparent governance, and a commitment to quality control. The company places a high priority on the well-being of its personnel, mandating the use of personal protective gear as required by each occupation. Additionally, we extend EPF, ESI, and group insurance benefits to our personnel. As a result, the company is duly registered with EPF and ESI authorities.{" "}
                              </div>
                            </div>
                            <div
                              className="elementor-element elementor-element-79842303 elementor-widget elementor-widget-text-editor"
                              data-id={79842303}
                              data-element_type="widget"
                              data-widget_type="text-editor.default"
                            >
                              {/* <div className="elementor-widget-container">
                                Fringilla mauris magna sit elementum elit.
                                Facilisi lacus, pharetra quam eu urna amet
                                aenean. Nunc mattis vitae tellus bibendum a eu,
                                nunc. Consequat commodo ac cursus in donec orci
                                tempus. Massa sed sit faucibus neque habitant
                                consequat.{" "}
                              </div> */}
                            </div>

                            {/* <section
                              className="elementor-section elementor-inner-section elementor-element elementor-element-383508d4 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="383508d4"
                              data-element_type="section"
                            >
                              <div className="elementor-container elementor-column-gap-no">
                                <div
                                  className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-6f24a60d"
                                  data-id="6f24a60d"
                                  data-element_type="column"
                                >
                                  <div className="elementor-widget-wrap elementor-element-populated">
                                    <div
                                      className="elementor-element elementor-element-7534fbdc elementor-view-stacked elementor-position-left elementor-shape-circle elementor-mobile-position-top elementor-widget elementor-widget-icon-box"
                                      data-id="7534fbdc"
                                      data-element_type="widget"
                                      data-widget_type="icon-box.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <div className="elementor-icon-box-wrapper">
                                          <div className="elementor-icon-box-icon">
                                            <span className="elementor-icon">
                                              <svg
                                                aria-hidden="true"
                                                className="e-font-icon-svg e-fas-check-double"
                                                viewBox="0 0 512 512"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <path d="M505 174.8l-39.6-39.6c-9.4-9.4-24.6-9.4-33.9 0L192 374.7 80.6 263.2c-9.4-9.4-24.6-9.4-33.9 0L7 302.9c-9.4 9.4-9.4 24.6 0 34L175 505c9.4 9.4 24.6 9.4 33.9 0l296-296.2c9.4-9.5 9.4-24.7.1-34zm-324.3 106c6.2 6.3 16.4 6.3 22.6 0l208-208.2c6.2-6.3 6.2-16.4 0-22.6L366.1 4.7c-6.2-6.3-16.4-6.3-22.6 0L192 156.2l-55.4-55.5c-6.2-6.3-16.4-6.3-22.6 0L68.7 146c-6.2 6.3-6.2 16.4 0 22.6l112 112.2z" />
                                              </svg>{" "}
                                            </span>
                                          </div>
                                          <div className="elementor-icon-box-content">
                                            <h3 className="elementor-icon-box-title">
                                              <span>Waste Collection </span>
                                            </h3>
                                            <p className="elementor-icon-box-description">
                                              Lorem ipsum dolor sit amet
                                              consectur adipicing elit duis et
                                              enim just.{" "}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-5a38b928"
                                  data-id="5a38b928"
                                  data-element_type="column"
                                >
                                  <div className="elementor-widget-wrap elementor-element-populated">
                                    <div
                                      className="elementor-element elementor-element-5cc90791 elementor-view-stacked elementor-position-left elementor-shape-circle elementor-mobile-position-top elementor-widget elementor-widget-icon-box"
                                      data-id="5cc90791"
                                      data-element_type="widget"
                                      data-widget_type="icon-box.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <div className="elementor-icon-box-wrapper">
                                          <div className="elementor-icon-box-icon">
                                            <span className="elementor-icon">
                                              <svg
                                                aria-hidden="true"
                                                className="e-font-icon-svg e-fas-check-double"
                                                viewBox="0 0 512 512"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <path d="M505 174.8l-39.6-39.6c-9.4-9.4-24.6-9.4-33.9 0L192 374.7 80.6 263.2c-9.4-9.4-24.6-9.4-33.9 0L7 302.9c-9.4 9.4-9.4 24.6 0 34L175 505c9.4 9.4 24.6 9.4 33.9 0l296-296.2c9.4-9.5 9.4-24.7.1-34zm-324.3 106c6.2 6.3 16.4 6.3 22.6 0l208-208.2c6.2-6.3 6.2-16.4 0-22.6L366.1 4.7c-6.2-6.3-16.4-6.3-22.6 0L192 156.2l-55.4-55.5c-6.2-6.3-16.4-6.3-22.6 0L68.7 146c-6.2 6.3-6.2 16.4 0 22.6l112 112.2z" />
                                              </svg>{" "}
                                            </span>
                                          </div>
                                          <div className="elementor-icon-box-content">
                                            <h3 className="elementor-icon-box-title">
                                              <span>Waste Collection </span>
                                            </h3>
                                            <p className="elementor-icon-box-description">
                                              Lorem ipsum dolor sit amet
                                              consectur adipicing elit duis et
                                              enim just.{" "}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section> */}
                            <div
                              className="elementor-element elementor-element-55a888e0 elementor-widget elementor-widget-heading"
                              data-id="55a888e0"
                              data-element_type="widget"
                              data-widget_type="heading.default"
                            >
                              <div className="elementor-widget-container">
                                <h2 className="elementor-heading-title elementor-size-default">
                                  Benefits of Service
                                </h2>{" "}
                              </div>
                            </div>
                            <div
                              className="elementor-element elementor-element-5f50bffa elementor-widget elementor-widget-text-editor"
                              data-id="5f50bffa"
                              data-element_type="widget"
                              data-widget_type="text-editor.default"
                            >
                              <div className="elementor-widget-container">
                                Manpower services benefit businesses by providing a flexible, skilled workforce that can be quickly deployed to meet operational demands. They reduce recruitment and training costs, ease administrative burdens, and allow companies to focus on core activities.
                              </div>
                            </div>
                            <div
                              className="elementor-element elementor-element-53d4231e elementor-align-left icon_wastix elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                              data-id="53d4231e"
                              data-element_type="widget"
                              data-widget_type="icon-list.default"
                            >
                              <div className="elementor-widget-container">
                                <ul className="elementor-icon-list-items">
                                  <li className="elementor-icon-list-item">
                                    <a href="#">
                                      <span className="elementor-icon-list-icon">
                                        <svg
                                          aria-hidden="true"
                                          className="e-font-icon-svg e-fas-check"
                                          viewBox="0 0 512 512"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z" />
                                        </svg>{" "}
                                      </span>
                                      <span className="elementor-icon-list-text">
                                      Provides skilled workforce
                                      </span>
                                    </a>
                                  </li>
                                  <li className="elementor-icon-list-item">
                                    <a href="#">
                                      <span className="elementor-icon-list-icon">
                                        <svg
                                          aria-hidden="true"
                                          className="e-font-icon-svg e-fas-check"
                                          viewBox="0 0 512 512"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z" />
                                        </svg>{" "}
                                      </span>
                                      <span className="elementor-icon-list-text">
                                        Offers flexible staffing solutions
                                      </span>
                                    </a>
                                  </li>
                                  <li className="elementor-icon-list-item">
                                    <a href="#">
                                      <span className="elementor-icon-list-icon">
                                        <svg
                                          aria-hidden="true"
                                          className="e-font-icon-svg e-fas-check"
                                          viewBox="0 0 512 512"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z" />
                                        </svg>{" "}
                                      </span>
                                      <span className="elementor-icon-list-text">
                                        Supports project-based workforce needs
                                      </span>
                                    </a>
                                  </li>
                                   <li className="elementor-icon-list-item">
                                    <a href="#">
                                      <span className="elementor-icon-list-icon">
                                        <svg
                                          aria-hidden="true"
                                          className="e-font-icon-svg e-fas-check"
                                          viewBox="0 0 512 512"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z" />
                                        </svg>{" "}
                                      </span>
                                      <span className="elementor-icon-list-text">
                                        Reduces hiring and training costs
                                      </span>
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <section
                              className="elementor-section elementor-inner-section elementor-element elementor-element-63f81686 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="63f81686"
                              data-element_type="section"
                            >
                              <div className="elementor-container elementor-column-gap-no">
                                <div
                                  className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-72349e19"
                                  data-id="72349e19"
                                  data-element_type="column"
                                >
                                  <div className="elementor-widget-wrap elementor-element-populated">
                                    <div
                                      className="elementor-element elementor-element-3a60b417 elementor-widget elementor-widget-image"
                                      data-id="3a60b417"
                                      data-element_type="widget"
                                      data-widget_type="image.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <img
                                          decoding="async"
                                          width={410}
                                          height={270}
                                          src="Untitled design (37).png"
                                          className="attachment-large size-large wp-image-1086"
                                          alt=""
                                        />{" "}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-68baf07f"
                                  data-id="68baf07f"
                                  data-element_type="column"
                                >
                                  <div className="elementor-widget-wrap elementor-element-populated">
                                    <div
                                      className="elementor-element elementor-element-3349de7e elementor-widget elementor-widget-image"
                                      data-id="3349de7e"
                                      data-element_type="widget"
                                      data-widget_type="image.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <img
                                          loading="lazy"
                                          decoding="async"
                                          width={410}
                                          height={270}
                                          src="Untitled design (38).png"
                                          className="attachment-large size-large wp-image-1085"
                                          alt=""
                                        />{" "}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                            {/* <div
                              className="elementor-element elementor-element-62f23f11 elementor-widget elementor-widget-heading"
                              data-id="62f23f11"
                              data-element_type="widget"
                              data-widget_type="heading.default"
                            >
                              <div className="elementor-widget-container">
                                <h2 className="elementor-heading-title elementor-size-default">
                                  Our Solutions
                                </h2>{" "}
                              </div>
                            </div>
                            <div
                              className="elementor-element elementor-element-723e6df1 elementor-widget elementor-widget-text-editor"
                              data-id="723e6df1"
                              data-element_type="widget"
                              data-widget_type="text-editor.default"
                            >
                              <div className="elementor-widget-container">
                                Lorem ipsum dolor sit amet consectetur
                                adipiscing elit duis et enim justo, in mauris
                                posuere dolor felis egestas ut venenatis
                                faucibus non sed faucibus mauris ultricies cras
                                varius proin amet vehicula magna ultricies
                                gravida vel volutpat sed platea
                              </div>
                            </div>
                            <div
                              className="elementor-element elementor-element-726b8d7a elementor-widget elementor-widget-heading"
                              data-id="726b8d7a"
                              data-element_type="widget"
                              data-widget_type="heading.default"
                            >
                              <div className="elementor-widget-container">
                                <h2 className="elementor-heading-title elementor-size-default">
                                  We help you with the dedication
                                </h2>{" "}
                              </div>
                            </div>
                            <div
                              className="elementor-element elementor-element-73b39ac7 wastix_accordion_01 elementor-widget elementor-widget-accordion"
                              data-id="73b39ac7"
                              data-element_type="widget"
                              data-widget_type="accordion.default"
                            >
                              <div className="elementor-widget-container">
                                <div className="elementor-accordion">
                                  <div className="elementor-accordion-item">
                                    <div
                                      id="elementor-tab-title-1941"
                                      className="elementor-tab-title"
                                      data-tab={1}
                                      role="button"
                                      aria-controls="elementor-tab-content-1941"
                                      aria-expanded="false"
                                    >
                                      <span
                                        className="elementor-accordion-icon elementor-accordion-icon-right"
                                        aria-hidden="true"
                                      >
                                        <span className="elementor-accordion-icon-closed">
                                          <svg
                                            className="e-font-icon-svg e-fas-chevron-down"
                                            viewBox="0 0 448 512"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z" />
                                          </svg>
                                        </span>
                                        <span className="elementor-accordion-icon-opened">
                                          <svg
                                            className="e-font-icon-svg e-fas-chevron-up"
                                            viewBox="0 0 448 512"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path d="M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z" />
                                          </svg>
                                        </span>
                                      </span>
                                      <a
                                        className="elementor-accordion-title"
                                        tabIndex={0}
                                      >
                                        What size container is right for my
                                        business?
                                      </a>
                                    </div>
                                    <div
                                      id="elementor-tab-content-1941"
                                      className="elementor-tab-content elementor-clearfix"
                                      data-tab={1}
                                      role="region"
                                      aria-labelledby="elementor-tab-title-1941"
                                    >
                                      Sodales posuere facilisi metus elementum
                                      ipsum egestas amet amet mattis commodo
                                      Nunc tempor amet massa diam mauris risus
                                      sodales interdum faucibus non sed faucibus
                                      mauris ultricies cras varius proin amet
                                      vehicula magna
                                    </div>
                                  </div>
                                  <div className="elementor-accordion-item">
                                    <div
                                      id="elementor-tab-title-1942"
                                      className="elementor-tab-title"
                                      data-tab={2}
                                      role="button"
                                      aria-controls="elementor-tab-content-1942"
                                      aria-expanded="false"
                                    >
                                      <span
                                        className="elementor-accordion-icon elementor-accordion-icon-right"
                                        aria-hidden="true"
                                      >
                                        <span className="elementor-accordion-icon-closed">
                                          <svg
                                            className="e-font-icon-svg e-fas-chevron-down"
                                            viewBox="0 0 448 512"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z" />
                                          </svg>
                                        </span>
                                        <span className="elementor-accordion-icon-opened">
                                          <svg
                                            className="e-font-icon-svg e-fas-chevron-up"
                                            viewBox="0 0 448 512"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path d="M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z" />
                                          </svg>
                                        </span>
                                      </span>
                                      <a
                                        className="elementor-accordion-title"
                                        tabIndex={0}
                                      >
                                        Where will my business trash bins be
                                        located?
                                      </a>
                                    </div>
                                    <div
                                      id="elementor-tab-content-1942"
                                      className="elementor-tab-content elementor-clearfix"
                                      data-tab={2}
                                      role="region"
                                      aria-labelledby="elementor-tab-title-1942"
                                    >
                                      Sodales posuere facilisi metus elementum
                                      ipsum egestas amet amet mattis commodo
                                      Nunc tempor amet massa diam mauris risus
                                      sodales interdum faucibus non sed faucibus
                                      mauris ultricies cras varius proin amet
                                      vehicula magna
                                    </div>
                                  </div>
                                  <div className="elementor-accordion-item">
                                    <div
                                      id="elementor-tab-title-1943"
                                      className="elementor-tab-title"
                                      data-tab={3}
                                      role="button"
                                      aria-controls="elementor-tab-content-1943"
                                      aria-expanded="false"
                                    >
                                      <span
                                        className="elementor-accordion-icon elementor-accordion-icon-right"
                                        aria-hidden="true"
                                      >
                                        <span className="elementor-accordion-icon-closed">
                                          <svg
                                            className="e-font-icon-svg e-fas-chevron-down"
                                            viewBox="0 0 448 512"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z" />
                                          </svg>
                                        </span>
                                        <span className="elementor-accordion-icon-opened">
                                          <svg
                                            className="e-font-icon-svg e-fas-chevron-up"
                                            viewBox="0 0 448 512"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path d="M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z" />
                                          </svg>
                                        </span>
                                      </span>
                                      <a
                                        className="elementor-accordion-title"
                                        tabIndex={0}
                                      >
                                        How often is business trash picked up?
                                      </a>
                                    </div>
                                    <div
                                      id="elementor-tab-content-1943"
                                      className="elementor-tab-content elementor-clearfix"
                                      data-tab={3}
                                      role="region"
                                      aria-labelledby="elementor-tab-title-1943"
                                    >
                                      Sodales posuere facilisi metus elementum
                                      ipsum egestas amet amet mattis commodo
                                      Nunc tempor amet massa diam mauris risus
                                      sodales interdum faucibus non sed faucibus
                                      mauris ultricies cras varius proin amet
                                      vehicula magna
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div> */}
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
                <div className="clearfix" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />

      {/* scroll to top */}
      {/*Scroll to top*/}
      <div className="mr_scroll-to-top">
        <div>
          <div className="mr_scroll-top-inner">
            <div className="mr_scroll-bar">
              <div className="mr_bar-inner" />
            </div>
            <div className="mr_bar_icon">
              <i className="fas fa-arrow-left" />
            </div>
          </div>
        </div>
      </div>
      {/* Scroll to top end */}
      {/* Scroll to top end */}
      {/*Search Popup*/}
    </main>
  );
};

export default Manpower;
